import CartGroceryOrderCard from './CartGroceryOrderCard';

export default CartGroceryOrderCard;
